import SearchAdgroupPage from '@/components/google-ads/search/SearchAdgroupPage';
import { TRAFFIC_OBJECTIVE } from './trafficObjective';

/** ADD AD GROUPS TO A TRAFFIC CAMPAIGN — /google-ads/traffic/create/adgroup */
export default function CreateTrafficAdgroup() {
  return <SearchAdgroupPage objective={TRAFFIC_OBJECTIVE} />;
}
